import React, {Component} from 'react';
import {Spinner} from "reactstrap";
import {Currency} from "buenLib/domain/Currency";
import {UserAccountData} from "components/dashboard/deposit-and-withdraw/deposits/fiat/UserAccountData";
import {AddAccount} from "./AddAccount";
import 'assets/sass/dashboard/deposits/withdraws/Accounts.scss';
import {app} from "app/app";
import {ModalWithReadCheck} from "components/common/ModalWithReadCheck";
import {Modal} from "components/common/Modal";

export class Accounts extends Component {
    renderOwnAccounts() {
        if (this.ownAccounts().length > 0) {
            return this.ownAccounts().map(bankAccount => {
                return <UserAccountData key={bankAccount.accountIdentifier()}
                                        isSelected={this.props.selectedAccount === bankAccount}
                                        handleAccountSelect={this.props.handleWithdrawAccountChange}
                                        handleDeleteBankAccount={this.props.handleDeleteBankAccount}
                                        data={bankAccount}/>
            });
        } else {
            return "No hay cuentas propias agendadas."
        }
    }

    ownAccounts() {
        return this.props.bankAccountBook.ownAccountsWithCurrency(this.props.currency)
    }

    internalThirdPartyAccounts() {
        if (this.props.bankAccountBook.internalThirdPartyAccounts().length > 0) {
            return this.props.bankAccountBook.internalThirdPartyAccounts().map(bankAccount => {
                return <UserAccountData key={bankAccount.accountIdentifier()}
                                        isSelected={this.props.selectedAccount === bankAccount}
                                        handleAccountSelect={this.props.handleWithdrawAccountChange}
                                        handleDeleteBankAccount={this.props.handleDeleteBankAccount}
                                        data={bankAccount}/>
            });
        } else {
            return `No hay cuentas de terceros en ${app.productName()} agendadas.`
        }
    }

    externalThirdPartyAccounts() {
        if (this.props.bankAccountBook.externalThirdPartyAccountsWithCurrency(this.props.currency).length > 0) {
            return this.props.bankAccountBook.externalThirdPartyAccountsWithCurrency(this.props.currency).map(
                bankAccount => {
                    return <UserAccountData key={bankAccount.accountIdentifier()}
                                            isSelected={this.props.selectedAccount === bankAccount}
                                            handleAccountSelect={this.props.handleWithdrawAccountChange}
                                            handleDeleteBankAccount={this.props.handleDeleteBankAccount}
                                            data={bankAccount}/>
                });
        } else {
            return "No hay cuentas de terceros en bancos agendadas."
        }
    }

    renderButtons() {
        if (app.currentUser().canWithdrawFiat()) {
            return (
                <div className="footer-buttons">
                    <button className={"cta-button mr-2" + (this.props.canContinue ? '' : ' disabled')}
                            onClick={this.props.handleContinue}>
                        CONTINUAR TRANSFERENCIA
                    </button>
                    <AddAccount
                        handleConfirmationTokenChange={this.props.handleConfirmationTokenChange}
                        {...this.props}
                    />
                </div>
            )
        } else {
            let verificationStateCode = app.currentUser().verificationState().code();
            let errorMessage = app.errorMessageMapper()[verificationStateCode]
            return <p> [ ! ] {errorMessage} </p>;
        }
    }

    renderExternalThirdPartyAccounts() {
        if (this.props.currency === Currency.ARS) {
            return (
                <>
                    <h6>Cuentas de terceros en bancos</h6>
                    {this.externalThirdPartyAccounts()}
                    <hr className="my-5"/>
                </>
            )
        }
    }

    renderUSDWarningModal() {
        if (this.props.currency === Currency.USD)
            return <ModalWithReadCheck modalName={"USDWithdrawWarningModal"} type={Modal.MODAL_TYPES.warning}
                                       title="¡Atención!" canBeDismissed={false}>
                <p>
                    Para reducir el riesgo de que las transferencias en dólares hacia tu banco se demoren o rechacen te
                    recomendamos las siguientes acciones:
                    <br/>
                    <br/>
                    <li>Agendar en tu banco nuestro CBU en pesos, y nuestro CBU en dólares.</li>
                    <li>Notificar al banco la procedencia de la transferencia. Recordá que todas las operaciones
                        en {app.productName()} emiten el comprobante correspondiente.
                    </li>
                    <li>Minimizar la cantidad de transferencias en dólares desde {app.productName()} hacia tu banco.
                    </li>
                </p>
            </ModalWithReadCheck>;
    }

    render() {
        if (this.props.loadingBankAccounts) {
            return (
                <div className="spinner">
                    <Spinner className="spinner-color"/>
                </div>
            )
        } else {
            return (
                <div>
                    {this.renderUSDWarningModal()}
                    <p>Seleccioná la cuenta a la que querés transferir tu saldo. Si es la primera vez, hacé click en
                        "Agregar cuenta"</p>
                    <h6>Cuentas propias</h6>
                    {this.renderOwnAccounts()}
                    <hr className="mb-4 mt-2"/>
                    {/*<h6>Cuentas de terceros en {app.productName()}</h6>*/}
                    {/*{this.internalThirdPartyAccounts()}*/}
                    {/*<hr className="my-5" />*/}
                    {/*{this.renderExternalThirdPartyAccounts()}*/}
                    {this.renderButtons()}
                </div>
            );
        }
    }
}
